import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AnalyticsService, DerivedCountryService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { RecaptchaComponent } from 'ng-recaptcha'
import { SeFeFormService } from 'se-fe-form-service'

import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { PasswordFormSubmitter } from './create-password-submit.service'
import { PasswordFormCreateService } from './password-form-create.service'

@Component({
  selector: 'se-po-household-setup-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {

  @ViewChild('captchaRef') public captchaRef: RecaptchaComponent

  public recaptchaKey: string
  public ready = false
  public form: UntypedFormGroup
  public fieldType = 'password'
  public iconName = 'hidden'
  public email = ''

  private derivedCountry = ''
  private readonly app = 'SingleSignOn'
  private readonly page = 'SignUp'
  private readonly label = 'Step2'

  constructor(
    private analyticsService: AnalyticsService,
    public derivedCountryService: DerivedCountryService,
    private formCreator: PasswordFormCreateService,
    private formService: SeFeFormService,
    public setupBarService: SetupBarService,
    private store: StoreService,
    private submitter: PasswordFormSubmitter
  ) { }

  public get unknownError(): boolean {
    return this.submitter.unknownError
  }

  public get submitting(): boolean {
    return this.submitter.submitting
  }

  public set submitting(val: boolean) {
    this.submitter.submitting = val
  }

  public async ngOnInit(): Promise<void> {
    this.submitter.validateAccount(this.store)
    this.initCaptcha()
    await this.setDerivedCountry()
    this.createForm()
    this.email = this.store?.accountInfo?.email
    this.analyticsService.pageView(this.app, this.page, this.label)
    this.setupBarService.setAttributes({
      title: 'Create Account',
      percentComplete: 75
    })
  }

  public toggleFieldType(): void {
    this.fieldType = this.fieldType === 'text' ? 'password' : 'text'
    this.iconName = this.fieldType === 'text' ? 'visible' : 'hidden'
  }

  public submit(): void {
    this.analyticsService.seEvent('SignUpButtonMainClick')
    this.submitting = true
    if (!this.formService.isValid(this.form)) {
      this.analyticsService.trackFormErrors(this.form)
      this.submitting = false
      return
    }

    this.store.patchAccountInfo({
      password: this.form.value.password,
      specialOffers: this.form.value.specialOffers ,
      thirdPartyMailing: this.form.value.thirdPartyMailing
    })
    this.submitter.validateAndSubmit(this.store, this.captchaRef)
  }

  public recaptchaResolved(captchaResponse: string): void {
    this.store.captchaResponse = captchaResponse
    this.submitter.submit(this.store)
  }

  public recaptchaErrored(): void {
    this.submitting = false
    this.analyticsService.trackError('CaptchaVerificationFailed.PleaseTryAgain')
  }

  public prefillMarketingCheckboxes(): boolean {
    return this.derivedCountry === 'US'
  }

  private createForm(): void {
    this.form = this.formCreator.createForm(this.prefillMarketingCheckboxes())
    this.ready = true
  }

  private initCaptcha(): void {
    if ((this.store.accountInfo?.email || '').endsWith('@sportngin.com')) {
      this.store.captchaResponse = 'sportngin'
    }
    else {
      this.store.captchaResponse = undefined
      this.recaptchaKey = environment.recaptchaV2SiteKey
    }
  }

  private async setDerivedCountry(): Promise<void> {
    return new Promise((resolve) => {
      this.derivedCountryService.show().subscribe(
        (result) => {
          this.derivedCountry = result.country
          resolve()
        },
        (err) => {
          console.error('Error fetching derived country', err)
          resolve()
        }
      )
    })
  }
}
